import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-page-title",
  templateUrl: "./page-title.component.html",
  styleUrls: ["./page-title.component.scss"],
})
export class PageTitleComponent implements OnInit {

  constructor(public route: ActivatedRoute) {}

  title = "";

  ngOnInit(): void {
    this.title = this.route.snapshot.routeConfig?.title + "";
  }
}
